// Libraries
import styled from "styled-components"


export const StyledSliderContainer = styled.div`
  .MuiSlider-root {
    color: #000A12;
  }
`
